import {computed} from "mobx";
import {OddsRateModel} from "../../odds-rate/models/odds-rate.model";
import {RateOptionDomainModel} from "./rate-option.domain-model";
import {ODDS_TYPES} from "../../../../../core/components/odds/components/odds-consts";
import {BaseViewModel} from "../../../../../infrastructure/models/base-view-model";
import {EXTRA_LINKS_CONTEXTS, TREND} from "../../../../../core/app/consts";
import {ExtraLinkDomainModel} from "../../extra-link/models/extra-link.domain-model";

export class RateOptionViewModel extends BaseViewModel {
  domainModel: RateOptionDomainModel;
  count: Number;
  oddsType: ODDS_TYPES;
  context: EXTRA_LINKS_CONTEXTS;

  constructor(domainModel: RateOptionDomainModel, oddsType: ODDS_TYPES, count: Number, context: EXTRA_LINKS_CONTEXTS) {
    super(domainModel);

    this.domainModel = domainModel;
    this.oddsType = oddsType;
    this.count = count;
    this.context = context;
    this.num = domainModel.num;
    this.isWon = domainModel.isWon;
  }

  @computed get oldRates(): OddsRateModel {
    return this.domainModel.oldRate;
  }

  @computed get rates(): OddsRateModel {
    return this.domainModel.rate;
  }

  @computed get preMatchRates(): OddsRateModel {
    return this.domainModel.preMatchRate;
  }

  @computed get originalRates(): OddsRateModel {
    return this.domainModel.originalRate;
  }

  get link(): String {
    let extraLink: ExtraLinkDomainModel = this.domainModel.extraLinks?.find((extraLink: ExtraLinkDomainModel) => extraLink.context === this.context);

    return extraLink?.link || this.domainModel.link;
  }

  get description(): String {
    const description = this.currentOldRate ? `${this.currentOldRate} >> ${this.currentRate}` : null;

    return description;
  }

  @computed get currentRate(): String {
    let currentRate = this.rates[this.oddsType] || (this.rates.decimal !== -1 ? this.rates.decimal : null);

    if (this.oddsType === ODDS_TYPES.decimal) {
      const fixed: Number = Math.ceil(currentRate).amountOfDigits() > 2 ? (Math.ceil(currentRate).amountOfDigits() > 3 ? 0 : 1) : 2;
      currentRate = `${currentRate.toFixed(fixed)}`;
    }

    const isValidRate: Boolean = this.isCurrentRateValid;
    currentRate = isValidRate ? currentRate : '-'

    return currentRate;
  }

  @computed get currentRateLength(): Number {
    return this.currentRate?.toString().length || 0;
  }

  @computed get isCurrentRateValid(): Boolean {
    const isCurrentRateValid: Boolean = this.rates?.decimal && (Number(this.rates.decimal) >= 0);

    return isCurrentRateValid
  }

  @computed get isPreMatchRateValid(): Boolean {
    const isPreMatchRateValid: Boolean = this.preMatchRates?.decimal && (Number(this.preMatchRates.decimal) >= 0);

    return isPreMatchRateValid
  }

  @computed get isOriginalRateValid(): Boolean {
    const isOriginalRateValid: Boolean = this.originalRates?.decimal && (Number(this.originalRates.decimal) >= 0);

    return isOriginalRateValid
  }

  @computed get currentOldRate(): String {
    if (!this.oldRates) {
      return null;
    }

    let currentRate = this.oldRates[this.oddsType] || this.oldRates?.decimal;

    if (currentRate === -1) {
      return null;
    }

    if (this.oddsType === ODDS_TYPES.decimal) {
      currentRate = `${currentRate.toFixed(2)}`;
    }

    return currentRate;
  }

  @computed get currentPreMatchRate(): String {
    if (!this.preMatchRates) {
      return null;
    }

    let currentPreMatchRate = this.preMatchRates[this.oddsType] || this.preMatchRates?.decimal;
    if (currentPreMatchRate === -1) {
      return null;
    }

    if (this.oddsType === ODDS_TYPES.decimal) {
      currentPreMatchRate = `${currentPreMatchRate.toFixed(2)}`;
    }

    return currentPreMatchRate;
  }

  @computed get trend(): Boolean {
    const trend: TREND = this.domainModel.trend;

    return trend;
  }

  get type(): String {
    const typeByNum = {
      2: {
        1: '1',
        2: '2'
      },
      3: {
        1: '1',
        2: 'X',
        3: '2'
      }
    }

    return typeByNum[this.count][this.num];
  }

  get isOddNum(): Boolean {
    return this.num % 2 === 0;
  }

  @computed get shouldRenderTrend(): Boolean {
    return this.isCurrentRateValid && this.trend !== TREND.even && this.trend !== 0;
  }

  roundRate(rate, selectedOddsType) {
    if (selectedOddsType === ODDS_TYPES.decimal) {
      const fixed = Math.ceil(rate).toString().length > 2 ? (Math.ceil(rate).toString().length > 3 ? 0 : 1) : 2;
      rate = rate.toFixed(fixed);
    }

    return rate;
  }
}
